module.exports = __webpack_public_path__ + "img/thumbnail_PrairieDog_m_albino.4fa2d833.png";